import { useEffect, useState } from "react";
import { Search, IdCard as IdIcon } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ROLE_LABELS } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EmptyState, PageHeader } from "@/components/common";
import { IdCard } from "@/components/IdCard";

export default function IdCardPage() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [role, setRole] = useState("all");
  useEffect(() => { api.get("/id-cards").then((r) => setRows(r.data)).catch((e) => { toast.error(errMsg(e)); setRows([]); }); }, []);
  const list = (rows || []).filter((u) => (role === "all" || u.role === role) && (!q || `${u.name} ${u.email} ${u.cabang_name || ""} ${u.wilayah_name || ""}`.toLowerCase().includes(q.toLowerCase())));
  return (
    <div>
      <PageHeader title="ID Card" />
      <div className="flex flex-wrap gap-3 mb-6">
        <div className="relative flex-1 min-w-[200px]"><Search className="h-4 w-4 absolute left-3 top-3.5 text-muted-foreground" /><Input className="h-11 pl-9" placeholder="Cari nama, email, kantor" value={q} onChange={(e) => setQ(e.target.value)} data-testid="idcard-search" /></div>
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger className="h-11 w-[200px]" data-testid="idcard-role-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Semua jabatan</SelectItem>{Object.entries(ROLE_LABELS).filter(([k]) => k !== "super_admin").map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {rows === null ? <p className="text-muted-foreground">Memuat...</p> : list.length === 0 ? <EmptyState icon={IdIcon} title="Tidak ada akun" text="Akun yang cocok akan tampil di sini." testId="idcard-empty" /> : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-testid="idcard-grid">{list.map((u) => <IdCard key={u.id} u={u} />)}</div>
      )}
    </div>
  );
}
